import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function HomeFinalCTA() {
  return (
    <section className="relative bg-[#0d4c7d] text-white overflow-hidden" data-testid="home-cta">
      <div className="grain absolute inset-0" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32 grid grid-cols-12 gap-8 items-center">
        <div className="col-span-12 md:col-span-8">
          <div className="overline mb-4 text-[#1FA8E0]">Fale com um especialista</div>
          <h2 className="font-display font-black uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight">
            Precisa de uma solução?<br />
            <span className="text-[#1FA8E0]">Encontre a opção ideal</span><br />
            para o seu projeto.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4 flex md:justify-end">
          <Link to="/contactos" data-testid="home-cta-btn" className="btn-cet btn-primary text-base">
            Contactar <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
